import React from 'react';
import { Input } from 'antd';
import Card from '../../../../../../components/Card/Card';
import { isQuestionRequired } from '../../utils/questions';

const { TextArea } = Input;

export default function QuestionsCard({
  accentColor,
  isReadOnly,
  currentQuestions,
  answers,
  answeredCount,
  activeLogEntry,
  facilitatorNote,
  onAnswerChange,
}) {
  return (
    <Card
      className="testing-exercising-card"
      color={accentColor}
      title="Validate your team's response"
      description={
        isReadOnly
          ? 'Review the recorded responses for this video. Answers are locked for this attempt.'
          : 'Answer the questions for this video. Use the incident-log bookmarks while you discuss and document responses.'
      }
    >
      <div className="testing-exercising-card-body testing-exercising-questions">
        <div className="testing-exercising-questions__progress">
          <div className="testing-exercising-questions__progress-bar" aria-hidden>
            <span
              style={{
                width: `${currentQuestions.length ? (answeredCount / currentQuestions.length) * 100 : 0}%`,
              }}
            />
          </div>
          <div className="testing-exercising-questions__count">
            {answeredCount} / {currentQuestions.length} answered
            {activeLogEntry?.time ? ` · section ${activeLogEntry.time}` : ''}
          </div>
        </div>

        {currentQuestions.map((question) => (
          <article
            key={question.questionId}
            className={`testing-exercising-question-card${
              String(answers[question.questionId] || '').trim() ? ' is-answered' : ''
            }`}
          >
            <h3>
              {question.questionText}
              {isQuestionRequired(question) ? <span className="required"> *</span> : null}
            </h3>
            {question.helpText ? <p className="testing-exercising-question-card__help">{question.helpText}</p> : null}
            <TextArea
              rows={3}
              value={answers[question.questionId] || ''}
              disabled={isReadOnly}
              placeholder={isReadOnly ? 'No response recorded.' : "Document your team's response..."}
              onChange={(event) => onAnswerChange(question.questionId, event.target.value)}
              aria-required={isQuestionRequired(question)}
            />
          </article>
        ))}

        {facilitatorNote ? (
          <aside className="testing-exercising-facilitator" aria-label="Facilitator note">
            <div className="testing-exercising-facilitator__icon" aria-hidden>
              i
            </div>
            <div>
              <div className="testing-exercising-facilitator__title">{facilitatorNote.title || 'Facilitator note'}</div>
              {(facilitatorNote.paragraphs || []).map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </aside>
        ) : null}
      </div>
    </Card>
  );
}
